// Explicit authentication also works outside the application's fetch wrapper.
export async function constructionRequest(url, options = {}) {
  const target = new URL(url, window.location.origin);
  if (target.origin !== window.location.origin || !target.pathname.startsWith('/api/')) {
    throw new Error('Construction requests must use the same-origin API.');
  }
  const headers = new Headers(options.headers);
  const token = localStorage.getItem('token');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(url, { ...options, headers });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(response.status === 401
      ? 'Your session has expired. Please sign in again.'
      : body.message || body.error || `Request failed (${response.status})`);
  }
  return response;
}

async function jsonRequest(url, method, data, options = {}) {
  const response = await constructionRequest(url, {
    ...options,
    method,
    ...(data === undefined ? {} : {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),
  });
  return { data: await response.json() };
}

const constructionApi = {
  get: (url, options) => jsonRequest(url, 'GET', undefined, options),
  post: (url, data) => jsonRequest(url, 'POST', data),
  put: (url, data) => jsonRequest(url, 'PUT', data),
  delete: (url) => jsonRequest(url, 'DELETE'),
};

export default constructionApi;
